<template>
    <div id="post-list-item" class="col-lg-4">
        <div class="owl-item active col-lg-12" ><div class="item">

            <ul class="list-post">
                <li class="clearfix">
                    <div class="post-block-style clearfix">
                        <div class="post-thumb">
                            <a :href="data.post_url">
                                <img class="img-fluid" :src="resizedThumbnail(data.thumbnail, 125)" :alt="data.title">
                            </a>
                        </div>
                        <a class="post-cat" :href="data.keywords_search_url" v-show="data.first_keyword">{{ data.first_keyword | capitalize }}</a>
                        <div class="post-content">
                            <h2 class="post-title title-medium">
                                <a :href="data.post_url">{{ data.title }}</a>
                            </h2>
                            <div class="post-meta">
                                <span class="post-author"><a :href="data.list_url">{{ data.menu_name }}</a></span>
                                <span class="post-date">{{ data.creation_date | formatShortDate }}</span>
                            </div>
                        </div><!-- Post content end -->
                    </div><!-- Post Block style end -->
                </li><!-- Li end -->
            </ul><!-- List post 2 end -->

        </div></div>
    </div>
</template>

<script>
    import { resizedThumbnail } from "../../helpers/helpers";

    export default {
        name: 'PostListItem',
        props: ['data'],
        data() {
            return {

            }
        },
        methods: {
            resizedThumbnail(url, height) {
                return resizedThumbnail(url, height);
            }
        }
    }
</script>

<style lang="scss">

    @import '~@/absctracts/variables.scss';
    @import '~@/absctracts/mixins.scss';

    #post-list-item {
        margin-bottom: 30px;
        margin-left: 0px;
        margin-right: 0;
        padding-left: 0;

        .owl-item {
            -webkit-backface-visibility: hidden;
            -webkit-tap-highlight-color: transparent;
            -webkit-touch-callout: none;
            float: left;
            min-height: 1px;
            position: relative;

            @media (max-width: 576px) {
                padding-right: 0 !important;
            }

            .list-post {
                list-style: none;
                margin: 0;
                padding: 0;

                .post-block-style {
                    overflow: hidden;
                    position: relative;

                    .post-thumb {
                        max-width: 100%;
                        overflow: hidden;
                        position: relative;

                        @media (max-width: 576px) {
                            img {
                                height: 185px !important;
                            }
                        }

                        img {
                            display: block;
                            width: 100%;
                            height: 125px;
                            object-fit: cover;
                            -webkit-transition: all .3s ease-out;
                            -o-transition: all .3s ease-out;
                            transition: all .3s ease-out;
                        }

                        img:hover {
                            @include imgHoverScale(1.15);
                        }
                    }

                    .post-cat {
                        position: absolute;
                        top: 20px;
                        margin-left: 20px;
                        z-index: 1;
                    }

                    .post-cat {
                        background: $red;
                    }

                    .post-cat:before {
                        border-right: 8px solid transparent;
                        border-top: 8px solid $red;
                        bottom: -8px;
                        content: '';
                        left: 0;
                        position: absolute;
                        z-index: 0;
                    }
                }
            }

            .post-content {
                padding: 0px;
                z-index: 1;
                position: relative;

                .post-title {
                    font-size: 16px;
                    line-height: 24px;
                    margin-top: 15px;
                    margin-bottom: 5px;
                    height: 50px;
                    overflow: hidden;

                    a {
                        color: $dark-grey;
                    }

                    a:hover {
                        color: $red;
                    }
                }

                .post-meta {
                    margin: 3px 0;

                    span {
                        font-size: 12px;
                        color: #a3a3a3;
                        margin-right: 8px;
                        padding-right: 10px;
                        border-right: 1px solid #dedede;
                        line-height: 12px;
                        display: inline-block;

                        .post-author {
                            a {
                                color: $dark-grey;
                                font-weight: 700;
                            }
                        }
                    }

                    .post-date {
                        border-right: 0;
                    }
                }
            }
        }

    }
</style>